import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import productData from "../Datas/productData";
import siteConfig from "../Datas/siteConfig";
import "../css/checkout.css";

const countries = [
  "Australia",
  "Austria",
  "Belgium",
  "Canada",
  "Denmark",
  "Finland",
  "France",
  "Germany",
  "Hong Kong SAR",
  "Ireland",
  "Italy",
  "Japan",
  "Luxembourg",
  "Malaysia",
  "Netherlands",
  "New Zealand",
  "Norway",
  "Portugal",
  "Singapore",
  "South Korea",
  "Spain",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Thailand",
  "United Kingdom",
  "United States",
];

function CheckOut() {
  const { cartItems } = useContext(CartContext);
  const [email, setEmail] = useState("");
  const lines = cartItems
    .map((item) => ({
      ...item,
      product: productData.find((product) => product.id === item.id),
    }))
    .filter((item) => item.product);
  const subtotal = lines.reduce(
    (total, item) => total + Number(item.product.price) * item.quantity,
    0
  );
  const shipping = 9.99;
  const total = subtotal + shipping;
  const submit = (event) => {
    event.preventDefault();
    const orderNo = `${Date.now()}${Math.floor(
      100000 + Math.random() * 900000
    )}`;
    const origin = window.location.origin;
    const params = new URLSearchParams({
      orderNo,
      amount: total.toFixed(2),
      currency: "USD",
      email,
      success_url: `${origin}/payment?state=success`,
      cancel_url: `${origin}/payment?state=cancel`,
      title: lines[0].product.name,
    });
    window.location.assign(`${origin}/create_payment.php?${params.toString()}`);
  };
  if (!lines.length)
    return (
      <main className="checkout-empty">
        <h1>Your cart is empty</h1>
        <Link to="/shop">Return to shop</Link>
      </main>
    );

  return (
    <main className="checkout-page">
      <div className="checkout-brand">
        <Link to="/">{siteConfig.brandName}</Link>
        <div>
          <span className="active">Information</span>
          <i>›</i>
          <span>Secure payment</span>
        </div>
      </div>
      <div className="checkout-layout">
        <section className="checkout-form">
          <form onSubmit={submit}>
            <h1>Contact & delivery</h1>
            <label>
              Email
              <input
                name="email"
                type="email"
                required
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <h2>Delivery address</h2>
            <label>
              Country / region
              <select name="country" defaultValue="Hong Kong SAR">
                {countries.map((country) => (
                  <option key={country}>{country}</option>
                ))}
              </select>
            </label>
            <div className="checkout-row">
              <label>
                First name
                <input name="firstName" required />
              </label>
              <label>
                Last name
                <input name="lastName" required />
              </label>
            </div>
            <label>
              Address
              <input name="address" required />
            </label>
            <label>
              Apartment, suite, etc. (optional)
              <input name="apartment" />
            </label>
            <div className="checkout-row">
              <label>
                City
                <input name="city" required />
              </label>
              <label>
                Postal code
                <input name="postalCode" required />
              </label>
            </div>
            <button type="submit">PAY ${total.toFixed(2)}</button>
          </form>
          <Link to="/returns" className="checkout-policy">
            Returns policy
          </Link>
          <Link to="/privacy" className="checkout-policy">
            Privacy policy
          </Link>
        </section>
        <aside className="checkout-summary">
          {lines.map((item) => (
            <div className="checkout-item" key={`${item.id}-${item.size}`}>
              <div>
                <img src={item.product.image} alt={item.product.name} />
                <span>{item.quantity}</span>
              </div>
              <p>
                {item.product.name}
                <small>{item.size}</small>
              </p>
              <strong>
                ${(Number(item.product.price) * item.quantity).toFixed(2)}
              </strong>
            </div>
          ))}
          <div className="summary-line">
            <span>Subtotal</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>
          <div className="summary-line">
            <span>Shipping</span>
            <span>${shipping.toFixed(2)}</span>
          </div>
          <div className="checkout-total">
            <span>
              Total <small>USD</small>
            </span>
            <strong>${total.toFixed(2)}</strong>
          </div>
        </aside>
      </div>
    </main>
  );
}
export default CheckOut;
